import { pino, type Logger } from 'pino';

type LogMethod = (messageOrObject: unknown, context?: unknown, ...args: unknown[]) => void;
type AppLogger = Omit<Logger, 'debug' | 'warn' | 'error'> & {
    debug: LogMethod;
    warn: LogMethod;
    error: LogMethod;
};

export const logger: AppLogger = pino({
    transport: {
        target: 'pino-pretty',
        options: {
            colorize: true,
        },
    },
    level: 'debug',
    redact: [],
}) as AppLogger;
